import { render } from "./MyCheckout.vue?vue&type=template&id=5b86e074&scoped=true"
import script from "./MyCheckout.vue?vue&type=script&lang=js"
export * from "./MyCheckout.vue?vue&type=script&lang=js"

import "./MyCheckout.vue?vue&type=style&index=0&id=5b86e074&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b86e074"]])

export default __exports__